module.exports = __webpack_public_path__ + "static/media/user-avatar-alt.7f0983fb.svg";